/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 202309d9 (Tue Mar 17 17:42:15 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface BackgroundCheckProcessingWebhookRequestBody
 */
export interface BackgroundCheckProcessingWebhookRequestBody {
  /**
   * Unique identifier for the background check.
   * @type string
   * @memberof BackgroundCheckProcessingWebhookRequestBody
   */
  id: string
  /**
   * Unique identifier of the user in Ministry Safe.
   * @type string
   * @memberof BackgroundCheckProcessingWebhookRequestBody
   */
  userId: string
  /**
   * Email address of the user.
   * @type string
   * @memberof BackgroundCheckProcessingWebhookRequestBody
   */
  email: string
  /**
   * External ID of the background check.
   * @type string
   * @memberof BackgroundCheckProcessingWebhookRequestBody
   */
  externalId: string
  /**
   * URL to the results of the background check.
   * @type string
   * @memberof BackgroundCheckProcessingWebhookRequestBody
   */
  resultsUrl: string
  /**
   * Date when the background check was completed.
   * @type Date
   * @memberof BackgroundCheckProcessingWebhookRequestBody
   */
  completeDate: Date
  /**
   * Status of the background check.
   * @type string
   * @memberof BackgroundCheckProcessingWebhookRequestBody
   */
  status?: string
}

export function BackgroundCheckProcessingWebhookRequestBodyFromJSON(
  json: any
): BackgroundCheckProcessingWebhookRequestBody {
  return BackgroundCheckProcessingWebhookRequestBodyFromJSONTyped(json, false)
}

export function BackgroundCheckProcessingWebhookRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BackgroundCheckProcessingWebhookRequestBody {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    userId: json['user_id'],
    email: json['email'],
    externalId: json['external_id'],
    resultsUrl: json['results_url'],
    completeDate: new Date(json['complete_date']),
    status: !exists(json, 'status') ? undefined : json['status'],
  }
}

export function BackgroundCheckProcessingWebhookRequestBodyToJSON(
  value?: BackgroundCheckProcessingWebhookRequestBody | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    user_id: value.userId,
    email: value.email,
    external_id: value.externalId,
    results_url: value.resultsUrl,
    complete_date: value.completeDate.toISOString().substr(0, 10),
    status: value.status,
  }
}
